import $ from "cash-dom";
import { getCart } from "../resources/shopify-cart";
import { cartItem } from "../templates/cart-item";
import { updateProgressBar } from "./cart-progress-bar";

class Cart {
	constructor() {
		const _ = this;

		_.currencyFormat = window.Luna.currency.format;
		_.cart = $('[data-component="cart"]');
		_.cartItems = $('[data-element="cart-items"]');

		_.cartFullPanel = $('[data-element="cart-full-panel"]');
		_.cartEmptyPanel = $('[data-element="cart-empty-panel"]');
		_.cartPanelHeader = $('[data-content="cart-header"]');

		_.open = false;

		_.bindUI();

		getCart()
			.then((data) => {
				_.render(data, false);
			})
			.catch((error) => {
				console.error(error);
			});
	}

	bindUI() {
		const _ = this;

		// Handle all click events at document level
		document.addEventListener("click", (e) => {
			// Find closest element with show-cart action
			const showTrigger = e.target.closest('[data-action-show-cart]');
			if (showTrigger) {
				e.preventDefault();
				showTrigger.setAttribute('aria-expanded', 'true');
				_.show();
			}

			// Find closest element with hide-cart action
			const hideTrigger = e.target.closest('[data-action-hide-cart]');
			if (hideTrigger) {
				e.preventDefault();
				_.hide();
			}
		});
	}

	show(data) {
		const _ = this;

		// render with data if we have it
		if (data) {
			_.render(data, true);
			return;
		}

		// get data first
		getCart()
			.then((data) => {
				_.render(data, true);
			})
			.catch((error) => {
				console.error(error);
			});
	}

	hide() {
		this.cart.attr("aria-hidden", "true");
		// Reset aria-expanded on all cart buttons
		document.querySelectorAll('[data-action-show-cart]').forEach(btn => {
			btn.setAttribute('aria-expanded', 'false');
		});
		this.open = false;
		document.body.style.overflow = "";
	}

	checkIfCartEmpty(cart) {
		const _ = this;

		if (cart.item_count > 0) {
			_.cartFullPanel.removeClass("hidden");
			_.cartEmptyPanel.addClass("hidden");
			_.cartPanelHeader.text("Your Order");
			return;
		}

		_.cartFullPanel.addClass("hidden");
		_.cartEmptyPanel.removeClass("hidden");
		_.cartPanelHeader.text("Your cart is empty");
		return;
	}

	renderCartItems(data) {
		let items = data.items;
		let html = "";
		let item = {};
		let price = "";
		let imageURL = "";

		for (var i = 0; i < items.length; ++i) {
			item = items[i];

			price = (item.discounted_price / 100).toFixed(2);
			price = this.currencyFormat.replace("{{amount}}", price);

			imageURL = item.image.replace(".jpg?", "_220x220_crop_center.jpg?");
			imageURL = imageURL.replace(".png?", "_220x220_crop_center.png?");
			html += cartItem(
				item.key,
				item.product_title,
				item.variant_title,
				item.url,
				item.image.replace(".jpg", "_200x.jpg"),
				item.quantity,
				price,
			);
		}
		this.cartItems.html(html);
	}

	updateSubtotal(data) {
		let subtotal = (data.items_subtotal_price / 100).toFixed(2);
		subtotal = this.currencyFormat.replace("{{amount}}", subtotal);
		$('[data-element="cart-subtotal"]').html(subtotal);
	}

	renderCartUpsell() {
		const upsellContainer = $('[data-content-cart-upsell]');

		if (!upsellContainer.length || !Luna.cartUpsell.enabled) return;

		// Fetch the cart-upsell section via Section Rendering API
		fetch('/?sections=cart-upsell')
			.then((response) => response.json())
			.then((data) => {
				if (data['cart-upsell']) {
					const html = document.createElement('div');
					html.innerHTML = data['cart-upsell'];
					const section = html.querySelector('#shopify-section-cart-upsell');

					upsellContainer.html(section ? section.innerHTML : data['cart-upsell']);
				}
			})
			.catch((error) => {
				console.error('Error fetching cart upsell section:', error);
			});
	}

	render(data, show = true) {
		const _ = this;
		_.checkIfCartEmpty(data);
		_.renderCartItems(data);
		_.updateSubtotal(data);
		updateProgressBar(data);
		_.renderCartUpsell();

		if (show) {
			setTimeout(() => {
				_.cart.attr("aria-hidden", "false");
				_.open = true;
				document.body.style.overflow = "hidden";
			}, 50);
		}
	}
}

const cart = new Cart();
let Luna = window.Luna || {};
Luna.cart = cart;

export { cart };
